import BauhausShape8 from "~/public/illustrations/v2/shapes/bauhaus-shape-8.svg?react";

export default function Loader() {
  return (
    <div className="inline-flex size-21 items-center justify-center gap-2.5 rounded-full bg-brand-secondary-200 p-6">
      <BauhausShape8 className="animate-accelerated-spin text-lemon" />
    </div>
  );
}
